import { render, staticRenderFns } from "./EditEmailForm.vue?vue&type=template&id=19ae67b5&"
import script from "./EditEmailForm.vue?vue&type=script&lang=js&"
export * from "./EditEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports